// extracted by mini-css-extract-plugin
export default {"radio-group-view":"radio-group-view_radio-group-view__m+rz0"};